// extracted by mini-css-extract-plugin
export default {"emptyState":"MonitoringView_emptyState__moxgg","collisionPreview":"MonitoringView_collisionPreview__-BPJi"};